import React from "react";
import footer1 from "assets/images/footer-1.svg";
import footer2 from "assets/images/footer-2.svg";
import footer3 from "assets/images/footer-3.svg";
import footer4 from "assets/images/footer-4.svg";
import footer5 from "assets/images/footer-5.svg";
import instagram from "assets/images/instagram.svg";
import whatsapp from "assets/images/whatsapp.svg";
import twitter from "assets/images/twitter.svg";
import nemad from "assets/images/logo-nemad.svg";
import neshan from "assets/images/logo-neshan.svg";
import { NavLink } from "react-router-dom";

import "./Footer.scss";

const Footer = () => {
  return (
    <div className="container-fluid container-xl">
      <div className="d-flex flex-column justify-content-center align-items-center footer-wrapper">
        <div className="footer-icon d-flex justify-content-evenly align-items-center w-100 gap-3 pb-4 flex-wrap">
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 footer-icon-item">
            <img src={footer5} alt="footer5" />
            <span>امکان تحویل اکسپرس</span>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 footer-icon-item">
            <img src={footer4} alt="footer4" />
            <span>ضمانت اصل بودن کالا</span>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 footer-icon-item">
            <img src={footer3} alt="footer3" />
            <span>7 روز هفته 24 ساعته</span>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 footer-icon-item">
            <img src={footer2} alt="footer2" />
            <span>پرداخت مطمئن</span>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 footer-icon-item">
            <img src={footer1} alt="footer1" />
            <span>امکان خرید گروهی</span>
          </div>
        </div>
        {/* <div
          id="footer-link"
          className="footer-links d-flex justify-content-center align-items-start mt-5 w-100 flex-wrap"
        > */}
        <div id="footer-link" className="footer-links mt-5 text-center row">
          {/* <div className="single-column d-flex flex-column justify-content-center align-items-center">
            <span>گروه مارکت</span>
            <div>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است،
              </p>
            </div>
          </div> */}
          {/* <div className="single-column d-flex flex-column justify-content-center align-items-center">
            <span className="text-nowrap">پشتیبانی گروه مارکت</span>
            <div>
              <NavLink to="#">تماس با ما</NavLink>
              <NavLink to="#">قوانین مقررات</NavLink>
              <NavLink to="#">سوالات متداول</NavLink>
            </div>
          </div> */}
          {/* <div className="single-column d-flex flex-column justify-content-center align-items-center">
            <span className="text-nowrap">لینک های سریع</span>
            <div>
              <NavLink to="#">سوالات متداول</NavLink>
              <NavLink to="#">انتقادات و پیشنهادات</NavLink>
              <NavLink to="#">قوانین و مقررات</NavLink>
              <NavLink to="#">حریم ‌خصوصی</NavLink>
            </div>
          </div> */}
          {/* <div className="single-column d-flex flex-column justify-content-center align-items-center">
            <span className="text-nowrap">راهنمای خرید از گروه مارکت</span>
            <div>
              <NavLink to="#">نحوه ثبت سفارش</NavLink>
              <NavLink to="#">رویه ارسال سفارش</NavLink>
              <NavLink to="#">شیوه های پرداخت</NavLink>
            </div>
          </div> */}
          <div className="col-md-8 col-sm-12">
            <h6
              className="text-center mb-3 fw-bold"
              style={{ color: "#ef6f6c" }}
            >
              گروهـــــــــمارکت
            </h6>
            <div style={{ width: "92%", margin: "auto" }}>
              <p className="footer-content">
                در گروهمارکت کاربران مختلف از جمله تولید کنندگان می توانند به
                همراه سایر تولید کنندگان همکار خود در سطح کشور مواد اولیه خود را
                بصورت گروهی یا ادغامی تهیه کنند. فروشگاه ها می توانند به همراه
                سایر فروشگاه های همکار خود در سطح کشور بصورت کاملا مستقیم از
                وارد کنندگان و تولید کنندگان بصورت گروهی وادغامی تهیه نمایند.
                مصرف کنندگان نیز می توانند انواع کالای مورد نیاز خود را از
                فروشگاه های عضو بصورت گروهی و ادغامی تهیه نمایند. ضمن اینکه در
                صورت عدم وجود کالا در فروشگاه های عضو این امکان وجود دارد که
                مصرف کنندگان با گروه فروشگاه ها ادغام شده و کالای مورد نیاز خود
                را بصورت مستقیم از واردکنندگان و تولید کنندگان دریافت نمایند.
                گروهمارکت از طریق قیمت گذاری پیشرفته سفارشات کوچک، متوسط و بزرگ
                همه کاربران را روی هم ادغام کرده و تبدیل به یک سفارش بسیار زیاد
                از کالای خاص می نماید. این ادغام و روی هم گذاشتن سفارشات موجب می
                شود قیمت کالا بر مبنای یک سفارش بزرگ محاسبه شده و همه سفارش
                دهندگان کوچک، متوسط و بزرگ را از کف قیمت اعلامی مبدا، یعنی تولید
                کنندگان و واردکنندگان برخوردار نماید.
              </p>
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <div className="single-column d-flex flex-column justify-content-center align-items-center mx-auto mt-4">
              <span className="text-nowrap">شبکه های اجتماعی</span>
              <div className="social-icons ">
                <img src={whatsapp} alt="whatsapp" />
                <img src={instagram} alt="instagram" />
                <img src={twitter} alt="twitter" />
              </div>
            </div>
            <div className="d-flex  align-items-center w-100 justify-content-center mt-4">
              <img src={nemad} alt="nemad" />
              <img src={neshan} alt="neshan" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
